import React, {Component, Fragment} from 'react';
import Datetime from 'react-datetime';
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import Toggle from 'react-toggle';
import {get} from '../../../server/actions'
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import {_addNotification, _addNotificationError, 
    formatDate,showFile, getModuleEnum, getAccessLevelByModule, groupBy} from "../../../server/util";
import {getLoginDistrictInfo} from "../../../server/utilDistrict";

const enumMealType={
    lunch:'Lunch',
    breakfast:'Breakfast',
    milk:'Milk',
    snack : 'Snack'
}
const modEnum=getModuleEnum();
var valid = function (current) {
    let maxDate=moment().add(2, 'months');
    if(current<=maxDate){
        return current.day() !== 0 && current.day() !== 6;
    }
    else{
        return false;
    }
    
};
class AuditReport extends Component {
    constructor(props){
        super(props)
        const reportsList =[{
            id:1,
            name: "Revenue Report"
        },
        {
            id:2,
            name:"Basic Claim"
        },
       /*  {
            id:3,
            name:"Audit Reports"
        }, */
        {
            id:4,
            name:"Income Report"
        },
        {
            id:5,
            name:"Daily Edit Check Report"
        },
        {
            id:6,
            name:"Online Deposits Report"
        },
        {
            id:7,
            name:"Temp Eligibility Report"
        },
        {
            id:8,
            name:"Account Balance Summary Report"
        },
        {
            id:9,
            name:"Monthly School Deposit Report"
        },
         {
            id:10,
            name:"Daily School Deposit Report"
        },
        {
           id:11,
           name:"Monthly Income Cash Report"
       }

    ]
        this.state={
            startDate:moment().startOf('month'),
            endDate:moment(),
            rptMonth:moment(),
            isLunch:true,
            mealType: enumMealType.lunch,
            rptType:0,
            loading: false,
            userInfo: getLoginDistrictInfo(),
            reportsList,
            isAuditRportSelected : false ,
            selectedReportType : 0,
            date:moment(),
            tempEligibilityData:[],
            accountBalSummaryReport:[],
            onlineDepositReport:[],
            dailySchoolDep:[],
            selectedSchoolId:this.props.selectSchool||0

        }
        this.renderInput=this.renderInput.bind(this);
        this.downloadReport=this.downloadReport.bind(this);
        this.onReportChange=this.onReportChange.bind(this);
    } 
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    } 
    componentWillReceiveProps=(nextProps)=>{
        if(nextProps.selectSchool!=this.props.selectedSchoolId){
            this.setState({selectedSchoolId:nextProps.selectSchool||0},()=>{
                if(this.state.selectedReportType==7){
                    this.getTempEligibilityData();
                }
                if(this.state.selectedReportType==8){
                    this.getAccountBalSummaryReport();
                }
                if(this.state.selectedReportType==6){
                    this.getOnlineDepositReport();
                }
                if(this.state.selectedReportType==10){
                    this.getDailySchoolDepDepositReport();
                }       
            })
        }        
    }  
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    setDate = (e) => {
        //alert(e)
        this.refs.calendar.closeCalendar()
        this.setState({date: e})
    }
    buildDataFormatForExport=()=>{
        const gradesMap=this.state.userInfo.gradesMap||[];
        const gradeGroup=groupBy(gradesMap,'value');
        return (
            [{
              columns: [{title:'SCHOOL'},{title:'PARENT EMAIL'},{title: 'STUDENT ID'}, {title: 'NAME'}, {title: 'GRADE'},
              {title: 'TEACHER'},{title: 'ELIGIBILITY'}],
              data: this.state.tempEligibilityData.map(item => {
                  return [{value: item.schoolName||''},{value:item.parentEmail||''},{value: item.studentId || ''}, {value: `${item.studentLName||''} ${item.studentFName||''}`}, {value: `${((gradeGroup[item.gradeName] || [])[0] || {}).label || ''}`}
                  , {value: item.teacherName || ''}, {value: `${(item.freeMeal) === true ? 'FreeMeals' : (item.reducedPrice)===true? 'ReducedPrice':'RegularPrice'}`}]
              })
            }]
        );
    }
    buildAccountBalSummaryDataFormatForExport=()=>{
        return (
            [{
              columns: [{title:'SCHOOL'},{title:'STAFF A/C BALANCE'},{title: 'STAFF NEGATIVE BALANCE'}, {title: 'STUDENT A/C BALANCE'},
              {title: 'STUDENT NEGATIVE BALANCE'}],
              data: this.state.accountBalSummaryReport.map(item => {
                  return [{value: item.schoolName||0},
                  {value:item.staffAccBalance||0},
                  {value: item.staffNegativeBalance || 0},
                  {value: item.stdAccBalance || 0},
                  {value: item.stdNegativeBalance||0}
                  ]
              })
            }]
        );
    }
    buildOnlineDepDataFormatForExport=()=>{
        const colsObj={
            "schoolName":"Site",
            "studentLName":"Student Last Name",
            "studentFName":"Student First Name",
            "transactionDate":"Transaction Date",
            "transactionTime":"Transaction Time",
            "amount":"Amount",
            "note":"Note",
            "paymentType":"Payment Type",
            "type":"Type",
            "checkNum":"Check / CC TX. No. / TX. ID"
        };
        return (
            [{
              columns: Object.values(colsObj||{}),
              data: this.state.onlineDepositReport.map(item => {
                  return Object.keys(colsObj).map(key=>{
                      return item[key]||''
                  })
              })
            }]
        );
    }
    builddailySchoolDepDataFormatForExport=()=>{
        const colsObj={
            "schoolName":"Site",
            "studentLName":"Student Last Name",
            "studentFName":"Student First Name",
            "transactionDate":"Transaction Date",
            "transactionTime":"Transaction Time",
            "amount":"Amount",
            "note":"Note",
            "paymentType":"Payment Type",
            "type":"Type",
            "checkNum":"Check / CC TX. No. / TX. ID"
        };
        return (
            [{
              columns: Object.values(colsObj||{}),
              data: this.state.dailySchoolDep.map(item => {
                  return Object.keys(colsObj).map(key=>{
                      return item[key]||''
                  })
              })
            }]
        );

    }
    getSystemDateTime = (date) =>{        
        let _datetime=moment(date,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")
        return _datetime;
    }
    getDailySchoolDepDepositReport=()=>{
        const districtID = this.state.userInfo.districtId;
        const schoolID = parseInt(this.props.selectSchool);
        const schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
        const s_d_id=schoolID>0?schoolID:districtID;
        let start = moment(this.state.startDate).format('YYYY-MM-DD')+"T00:00:00";
        let end = moment(this.state.endDate).format('YYYY-MM-DD')+"T23:59:59";
        const isDistId=schoolID>0?false:true;
        const _url=`/reports/schoolDepositReport/${s_d_id}?isFileData=true&startDate=${this.getSystemDateTime(start)}&endDate=${this.getSystemDateTime(end)}&schoolYear=${schoolYear}&isDistrict=${isDistId}&access_token=`;
        get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData=(data.transactionReportsDetails||[])
            this.setState({ dailySchoolDep: resData, loading:false})
        }).catch(error => {
            this.setState({ dailySchoolDep: [], loading:false})
            console.log("Loading Report Failed", error)
        });
    }
    getOnlineDepositReport=()=>{
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const s_d_id=schoolID>0?schoolID:districtID;
        const isSchool=schoolID>0?true:false;
        const schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
        let start = moment(this.state.startDate).format('YYYY-MM-DD')+"T00:00:00";
        let end = moment(this.state.endDate).format('YYYY-MM-DD')+"T23:59:59";  
        const _url='/reports/onlinePaymetReport?districtId='+s_d_id+'&isSchoolId='+isSchool+'&isFileData=true'+ '&startDate=' + this.getSystemDateTime(start)+ '&endDate=' + this.getSystemDateTime(end) +'&schoolYear='+schoolYear+'&access_token=';
        get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData=(data.transactionReportsDetails||[])
            this.setState({ onlineDepositReport: resData, loading:false})
        }).catch(error => {
            this.setState({ onlineDepositReport: [], loading:false})
            console.log("Loading Report Failed", error)
        });
    }
    getAccountBalSummaryReport=()=>{
        const schoolID = parseInt(this.props.selectSchool);
        const schoolYear = this.state.userInfo.schools[0].activeSchoolYear
        const districtID = this.state.userInfo.districtId
        const s_d_id=schoolID>0?schoolID:districtID
        const isDistId=schoolID>0?false:true;
        let start = this.getSystemDateTime(moment(this.state.startDate));
        const _url=`/reports/accBalanceSummary/${s_d_id}?isDistrict=${isDistId}&schoolYear=${schoolYear}&isExport=false&dateV=${start}&access_token=`;
        get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData=(data.response||[])
            this.setState({ accountBalSummaryReport: resData, loading:false})
        }).catch(error => {
            this.setState({ accountBalSummaryReport: [], loading:false})
            console.log("Loading Report Failed", error)
        })
    }
    getTempEligibilityData = () => {
        this.setState({loading:true})
        const schoolID = parseInt(this.props.selectSchool);
        const districtID = this.state.userInfo.districtId 
        const schoolYear = this.state.userInfo.schools[0].activeSchoolYear
        const s_d_id=schoolID>0?schoolID:districtID
        const isDistId=schoolID>0?false:true
        const _url=`/reports/fmActualReport?mealSchoolId=${s_d_id}&isDistId=${isDistId}&fileType=AllData&isTemp=true&schoolYear=${schoolYear}&access_token=`;
       get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData=(data.response||[])
            this.setState({ tempEligibilityData: resData, loading:false})
        }).catch(error => {
            this.setState({ tempEligibilityData: [], loading:false})
            console.log("Loading Report Failed", error)
        })
    };
    downloadReport=()=>{
        let isSchoolrequired = false;
        let _refNotify=this.props.refNotify;
        let _self=this;
        let schoolID = parseInt(this.props.selectSchool)
        const schoolData = this.state.userInfo.schools.find((item)=> {if(item.schoolId === parseInt(this.props.selectSchool)){
            console.log("item.activeSchoolYear------->",item.activeSchoolYear)
          return item
        }})
        let schoolYear = 0
        if(schoolData){
            schoolYear = schoolData.activeSchoolYear || 0
        }
        //this.setState({loading: true})
        var start = moment(this.state.startDate).format('YYYY-MM-DD')+"T00:00:00";
        var end = moment(this.state.endDate).format('YYYY-MM-DD')+"T23:59:59";  
        var districtID = this.state.userInfo.districtId   
        if(this.state.selectedReportType == 4 || this.state.selectedReportType == 5 || this.state.selectedReportType == 9 || this.state.selectedReportType == 10 || this.state.selectedReportType == 11) {
            var date=new Date(this.state.date)
            var firstDay=moment(date).startOf('M').format('YYYY-MM-DD')+"T00:00:00";
            var lastDay=moment(date).endOf('M').format('YYYY-MM-DD')+"T23:59:59";
            var yearMonth=moment(date).format('YYYYMM')
            //var date = new Date(this.state.date);
            //var firstDay = formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
            //var lastDay = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));

            //var yearMonth = date.getFullYear()+""+(date.getMonth()+1)
        }
        if(this.state.selectedReportType !== 0) {
            let _url=""
            let reportType = parseInt(this.state.selectedReportType)
            switch (reportType) {
                case 1 : 
                    end = moment(this.state.startDate).format('YYYY-MM-DD')+"T23:59:59"
                    _url= (!schoolID)?`/reports/revenueReport/0?distId=${districtID}&startDate=${moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&schoolYear=${moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format('YYYY')}&access_token=`
                    :'/reports/revenueReport/'+schoolID+'?startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                        '&schoolYear='+schoolYear+'&access_token='
                    break
                 case 2 : 
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
                    if(schoolID>0){
                        _url='/reports/generateAuditReport?mealSchoolId=' + schoolID 
                    + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
                     '&schoolYear='+schoolYear+'&access_token=';

                    }else{
                    _url='/reports/basicClaimReport?districtId='+districtID 
                        + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                        '&schoolYear='+schoolYear+'&access_token=';
                    }
                    break
                case 3 : 
                    if(schoolID>0){
                    _url='/reports/generateAuditReport?mealSchoolId=' + schoolID 
                    + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
                     '&schoolYear='+schoolYear+'&access_token=';

                    }else{
                        schoolYear = this.state.userInfo.schools[0].activeSchoolYear
                    _url='/reports/basicClaimReport?districtId=' + districtID 
                    + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                     '&schoolYear='+schoolYear+'&access_token=';
                    }
                    break
                case 4 :
                    if(schoolID>0){
                    _url='/reports/incomeReport/'+schoolID+'?&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
                     '&yearMonth='+yearMonth+'&access_token=';
                    }else{
                         _url='/reports/incomeReport/'+0+'?distId='+districtID+'&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
                     '&yearMonth='+yearMonth+'&access_token=';
                    }
                    break
                case 5 : 
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear
                    _url='/reports/auditDailyEditCheck?districtId='+districtID+'&mealSchoolId=' + schoolID 
                    + '&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
                     '&schoolYear='+schoolYear+'&yearMonth='+yearMonth+'&access_token='
                    break
                case 6 : 
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
                    if(schoolID>0){
                        _url='/reports/onlinePaymetReport?districtId='+schoolID+'&isSchoolId=true&isFileData=false'
                    + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                     '&schoolYear='+schoolYear+'&access_token=';

                    }else{
                    _url='/reports/onlinePaymetReport?districtId='+districtID+'&isFileData=false'
                    + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                     '&schoolYear='+schoolYear+'&access_token=';
                    }
                    break
                case 7 :
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear
                    const s_d_id=schoolID>0?schoolID:districtID
                    const isDistId=schoolID>0?false:true
                   _url=`/reports/fmActualReport?mealSchoolId=${s_d_id}&isDistId=${isDistId}&fileType=pdf&isTemp=true&schoolYear=${schoolYear}&access_token=`;
                    break;
                case 8:
                    const sd_id=schoolID>0?schoolID:districtID
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear
                    const isDistrict=schoolID>0?false:true;
                    let start1 = this.getSystemDateTime(moment(this.state.startDate));
                    _url=`/reports/accBalanceSummary/${sd_id}?isDistrict=${isDistrict}&schoolYear=${schoolYear}&isExport=true&dateV=${start1}&access_token=`;
                    break;
                case 9:
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
                    const s_d_id1=schoolID>0?schoolID:districtID
                    const isDistId1=schoolID>0?false:true;
                    const endDate=moment(this.state.date).endOf('M').format('YYYY-MM-DD')+"T23:59:59";
                    _url=`/reports/schoolDepositReport/${s_d_id1}?startDate=${moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(endDate,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&yearMonth=${yearMonth}&isDistrict=${isDistId1}&access_token=`;                
                break;
                case 10: 
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
                    const s_d_id2=schoolID>0?schoolID:districtID
                    const isDistId2=schoolID>0?false:true
                    _url=`/reports/schoolDepositReport/${s_d_id2}?startDate=${moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&isDistrict=${isDistId2}&schoolYear=${schoolYear}&isFileData=false&access_token=`;
                break;
                case 11 :
                    if(schoolID>0){
                    _url='/reports/incomeCashReport/'+schoolID+'?isDistId=false&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")+
                     '&yearMonth='+yearMonth+'&access_token=';
                    }else{
                         _url='/reports/incomeCashReport/'+districtID+'?isDistId=true&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                     '&yearMonth='+yearMonth+'&access_token=';
                    }
                    break
            }
            if(isSchoolrequired ){
                _addNotificationError("Please select school",_self)
                return
            }
           
            this.setState({loading: true})
             get(_url)
            .then((response) => {
                if (!response.ok) {
                    if(response.status===417|| response.status===422){
                        return response.json();
                    }
                    //throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if(res.statusCode===417){
                    _addNotificationError(res.statusMessage,this)
                    throw Error(res.errorMessage);
                }else if(res.statusCode===422){
                    throw Error(res.statusMessage);
                }else{
                    return res.blob();                
                } 
            }).then(blob => {
                let filename = reportType==7?"TempEligibilityReport":reportType==8?"BalanceSummaryReport":reportType==9?"MonthlySchoolDepositReport": reportType==10?"DailySchoolDepositReport": reportType==11?"MonthlyIncomeCashReport": "DailyEditCheckReport";
                showFile(blob,filename);            
                this.setState({loading: false})
            }).catch(
                (error) => {
                    let msg=''
                    if(typeof error==='string'){
                        msg=error;
                    }else{
                        msg=error.message;
                    }
                    _addNotificationError(msg,_self)
                    //console.log('Get Excel File response', error)
                    this.setState({loading: false})
                }
            )
            return
        }
    }
    onReportChange = (value)=>{
        this.setState({selectedReportType : value})
        if(value == 3) this.setState({isAuditRportSelected:true}) 
        else this.setState({isAuditRportSelected : false});
        if(value==7){
            this.getTempEligibilityData();
        }else if(value==8){
            this.setState({startDate:moment()},()=>{
                this.getAccountBalSummaryReport();
            });
            
        } else if(value==6){
            this.setState({
                startDate:moment().startOf('month'),
                endDate:moment(),
            },()=>{
                this.getOnlineDepositReport();
            })            
        } else if(value==10){
            this.setState({
                startDate:moment().startOf('month'),
                endDate:moment(),
            },()=>{
                this.getDailySchoolDepDepositReport();
            })            
        }
    }

   render(){
       return(
       <div className="row">  
       <NotificationSystem ref="notificationSystem"/>
       <div className='sweet-loading'
            style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
            <BeatLoader size={20} color={'#ea7066'} loading={this.state.loading} />
        </div>
       <div className="col-md-offset-3 col-md-6">
           <div className="panel ">
              <div className="panel-body">
               <div className="row">
                   <div className="col-md-12 ">
                   <select className="form-control  form-group"  
                        value={this.state.selectedReportType} 
                        onChange={(e)=>{
                            this.onReportChange(e.target.value);
                        }}>
                            <option selected value={0}>Select Report</option>
                            {
                                (this.state.reportsList||[]).map((item,k)=>{
                                    return <option key={k} value={item.id}>{item.name}</option>
                                })
                            }
                    </select>
                   </div>
                   
                   {(this.state.isAuditRportSelected || this.state.selectedReportType == 4 || this.state.selectedReportType == 5) && 
                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                        <label className="custom-label col-md-4 text-left" style={{margin: '18px 0px'}}>Report for</label>
                        <div className="input-group col-md-8 col-sm-12 col-xs-12">
                        <div className="row">
                        
                            <div className="styled-input-single col-md-4">
                                <input type="radio" name="mealType" id={'rb'+enumMealType.lunch} onChange={()=>{
                                    this.setState({mealType:enumMealType.lunch})
                                }} checked={this.state.mealType===enumMealType.lunch} />
                                <label htmlFor={'rb'+enumMealType.lunch}>{enumMealType.lunch}</label>
                            </div>
                            <div className="styled-input-single col-md-5">
                                <input type="radio" name="mealType" id={'rb'+enumMealType.breakfast} onChange={()=>{
                                    this.setState({mealType:enumMealType.breakfast})
                                }} checked={this.state.mealType===enumMealType.breakfast} />
                                <label htmlFor={'rb'+enumMealType.breakfast}>{enumMealType.breakfast}</label>
                            </div>            
                            { (this.state.selectedReportType == 4 || this.state.selectedReportType == 5) ? 

                                <div className="styled-input-single col-md-3">
                                <input type="radio" name="mealType" id={'rb'+enumMealType.snack} onChange={()=>{
                                    this.setState({mealType:enumMealType.snack})
                                }} checked={this.state.mealType===enumMealType.snack} />
                                <label htmlFor={'rb'+enumMealType.snack}>{enumMealType.snack}</label>
                                </div>
                                 : 
                                 <div className="styled-input-single col-md-3">
                                 <input type="radio" name="mealType" id={'rb'+enumMealType.milk} onChange={()=>{
                                     this.setState({mealType:enumMealType.milk})
                                 }} checked={this.state.mealType===enumMealType.milk} />
                                 <label htmlFor={'rb'+enumMealType.milk}>{enumMealType.milk}</label>
                             </div>

                            }
                           
                        </div>
                        </div>
                    </div>
                    }
                    {this.state.isAuditRportSelected &&                     
                    <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                        <div className="styled-input-single col-md-12" style={{margin: '-45px 15px'}}>
                            <input type="radio" name="rdRpt" id="rdSummaryRpt" onChange={()=>{
                                this.setState({rptType:0})
                            }} checked={this.state.rptType===0} />
                            <label htmlFor='rdSummaryRpt'>{'Summarized reimbursement claim report'}</label>
                        </div>
                        <div className="styled-input-single col-md-12" style={{margin: '-11px 15px'}}>
                            <input type="radio" name="rdRpt" id="rdDailyEditRpt" onChange={()=>{
                                this.setState({rptType:1})
                            }} checked={this.state.rptType===1} />
                            <label htmlFor='rdDailyEditRpt'>{'Daily edit check worksheet report'}</label>
                        </div>
                    </div>
                   
                    }
                    
                    {
                       ( this.state.selectedReportType == 1 || this.state.selectedReportType == 2 || this.state.selectedReportType == 3
                        || this.state.selectedReportType == 6 || this.state.selectedReportType == 8 || this.state.selectedReportType == 10)?
                        <div>
                           
                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                            <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}> {this.state.selectedReportType == 1 ? "Date" :  "Start Date" }</label>
                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                <Datetime ref='startCalendar' dateFormat={'YYYY/MM/DD'} timeFormat={false}
                                        closeOnSelect={true} value={this.state.startDate}
                                        onChange={(e)=>{
                                        this.setState({startDate:moment(e)},()=>{
                                            if(this.state.selectedReportType ==8){
                                                this.getAccountBalSummaryReport();
                                            }
                                            if(this.state.selectedReportType==6){
                                                this.getOnlineDepositReport();
                                            }
                                            if(this.state.selectedReportType==10){
                                                this.getDailySchoolDepDepositReport();
                                            }
                                        })
                                        this.refs.startCalendar.closeCalendar()
                                    }} renderInput={this.renderInput}/>
                            </div>
                        </div>
                        {(this.state.selectedReportType != 1 && this.state.selectedReportType != 8) &&
                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                            <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}>End Date</label>
                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                <Datetime ref='endCalendar' dateFormat={'YYYY/MM/DD'} timeFormat={false}
                                                            closeOnSelect={true} value={this.state.endDate}
                                    onChange={(e)=>{
                                        this.setState({endDate:moment(e)},()=>{
                                            if(this.state.selectedReportType==6){
                                                this.getOnlineDepositReport();
                                            }
                                            if(this.state.selectedReportType==10){
                                                this.getDailySchoolDepDepositReport();
                                            }
                                        })
                                        this.refs.endCalendar.closeCalendar()
                                    }} renderInput={this.renderInput}/>
                            </div>
                            </div>
                        }
                       
                        </div>:
                        null   
                    }
                    {
                        (this.state.selectedReportType == 4 || this.state.selectedReportType == 5 || this.state.selectedReportType == 9 || this.state.selectedReportType == 11) &&
                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                            <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}>Month</label>
                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                <Datetime inputProps={{placeholder: 'Select Month'}}
                                    ref='calendar' dateFormat="MMMM YYYY"
                                    timeFormat={false}
                                    value={this.state.date}
                                    closeOnSelect={true} isValidDate={valid}
                                    onChange={this.setDate}
                                    renderInput={this.renderInput}
                                />
                            </div>
                        </div>
                    }
                    {
                        this.state.selectedReportType != 0 &&
                        <Fragment>
                    <div className="row">
                        <div className="col-md-12">
                        <button className="btn btn-success btn-sm pull-right" onClick={(e)=>{
                            e.preventDefault();
                            this.downloadReport();
                        }}> Download Report
                        </button> 
                        {this.state.selectedReportType == 7 ?
                        <TmExportExcel
                        id={"tempEligibilityReport"} 
                        name={"TempEligibilityReport"}
                        filename={"Temp Eligibility Report"}
                        element={<button id={"tempEligibilityReport"} className="btn btn-warning btn-sm pull-right"><i className="fa fa-file-excel-o"></i> Export</button>}
                        dataSet={this.buildDataFormatForExport()}
                        />:null
                        }
                        {
                            this.state.selectedReportType == 8?
                            <TmExportExcel
                                id={"accountBalSummaryReport"} 
                                name={"AccountBalanceSummaryReport"}
                                filename={"Account Balance Summary Report"}
                                element={<button id={"accountBalSummaryReport"} className="btn btn-warning btn-sm pull-right"><i className="fa fa-file-excel-o"></i> Export</button>}
                                dataSet={this.buildAccountBalSummaryDataFormatForExport()}
                                />:null
                        }
                        {
                            this.state.selectedReportType == 6?
                            <TmExportExcel
                                id={"onlineDepositReport"} 
                                name={"Online Deposit Report"}
                                filename={"Online Deposit Report"}
                                element={<button id={"onlineDepositReport"} className="btn btn-warning btn-sm pull-right"><i className="fa fa-file-excel-o"></i> Export</button>}
                                dataSet={this.buildOnlineDepDataFormatForExport()}
                                />:null
                        }
                        {
                            this.state.selectedReportType == 10?
                            <TmExportExcel
                                id={"dailySchoolDepositReport"} 
                                name={"Daily School Deposit Report"}
                                filename={"dailySchoolDepositReport"}
                                element={<button id={"dailySchoolDepositReport"} className="btn btn-warning btn-sm pull-right"><i className="fa fa-file-excel-o"></i> Export</button>}
                                dataSet={this.builddailySchoolDepDataFormatForExport()}
                                />:null
                        }
                        </div>
                    </div>
                    </Fragment>
                    }
               </div>
              </div>
            </div>
            </div>
       </div>
       )
   }    
}
export default AuditReport



// WEBPACK FOOTER //
// ./src/components/District/auditReport/auditReportComponent.jsx